import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { h } from 'vue';
import dashboard from './modules';
import system from './modules/system';
import BasicLayout from '@/layouts/basic-layout';
import Setting from '@/setting';
import setting from './modules/setting';

/**
 * 在主框架内显示
 */

var frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: BasicLayout,
  children: [{
    path: '/log',
    name: 'system-log',
    meta: {
      title: '前端日志',
      auth: ['admin'],
      icon: 'md-locate'
    },
    component: function component() {
      return import('@/sys-pages/system/log');
    }
  },
  // 刷新页面 必须保留
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: {
      beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (instance) {
          return instance.$router.replace(from.fullPath);
        });
      },
      render: function render() {
        return h();
      }
    }
  },
  // 页面重定向 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: {
      beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (instance) {
          return instance.$router.replace(JSON.parse(from.params.route));
        });
      },
      render: function render() {
        return h();
      }
    }
  }]
}, dashboard, system, setting];

/**
 * 忽略导航守卫
 * @type {{ignoreFilter: boolean}}
 */
var ignoreFilterMeta = {
  noLogin: true
};

/**
 * 在主框架之外显示
 */
var frameOut = [
// 登录
{
  path: '/login',
  name: 'login',
  hidden: true,
  meta: _objectSpread(_objectSpread({}, ignoreFilterMeta), {}, {
    title: '$t:page.login.title'
  }),
  component: function component() {
    return import('@/sys-pages/account/login/index.vue');
  }
}];
if (Setting.isRegister) {
  frameOut.push(
  // 注册
  {
    path: '/register',
    name: 'register',
    hidden: true,
    meta: _objectSpread(_objectSpread({}, ignoreFilterMeta), {}, {
      title: '$t:page.register.title'
    }),
    component: function component() {
      return import('@/sys-pages/account/register');
    }
  });
}

// 导出需要显示菜单的
export var frameInRoutes = frameIn;

// 重新组织后导出
export default [].concat(frameIn, frameOut);